module.exports = __webpack_public_path__ + "static/img/02344_1.9859d56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02344_1.jpg
// module id = vUfP
// module chunks = 1